import { render, staticRenderFns } from "./OlderDetailFeeEnter.vue?vue&type=template&id=60cf2a3c&scoped=true"
import script from "./OlderDetailFeeEnter.vue?vue&type=script&lang=js"
export * from "./OlderDetailFeeEnter.vue?vue&type=script&lang=js"
import style0 from "./OlderDetailFeeEnter.vue?vue&type=style&index=0&id=60cf2a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cf2a3c",
  null
  
)

export default component.exports